import React, {useContext, createContext, useState, ReactNode} from 'react';

interface ViewContextType {
    userId: string;
}
export const ViewContext = createContext<ViewContextType>({
    userId: "",
});

interface ContextProviderProps {
    children: ReactNode;
}

const DocumentHistoryContextProvider = ({children}: ContextProviderProps) => {
    const [userId, setUserId] = useState("");

    const contextValues = {
        userId
    };


    return (
        <ViewContext.Provider value={contextValues}>
            {children}
        </ViewContext.Provider>
    );

};

const  useDocumentHistoryContext = () => {
    const context = useContext(ViewContext);

    if (context === undefined) {
        throw new Error('useContextProvider must be used within ContextProvider.');
    }

    return context;

}

export {
    DocumentHistoryContextProvider,
    useDocumentHistoryContext
}
